module.exports = __webpack_public_path__ + "static/test2-9433973db17e08c1a7eafaadea4113f2.png";